import styled from 'styled-components';
import { color, screen, spacing } from 'theme';

export const Root = styled.div`
  background: #fff;
  padding: ${spacing('xl6')} 0;

  h2 {
    color: ${color('indigo_700')};
  }
`;

export const Features = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 1.25rem;
  margin-top: 2rem;

  @media (max-width: ${screen('lg')}) {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }
`;

export const Feature = styled.div`
  h3 {
    color: ${color('indigo_700')};
    margin-bottom: 0.5rem;
    border-bottom: 2px solid ${color('indigo_300')};
    padding-bottom: 0.75rem;
    gap: 0.5rem;
    display: flex;
    position: relative;

    strong {
      display: inline-block;
      font-size: 1.25rem;
      border-radius: 100%;
      width: 2.25rem;
      height: 2rem;
      line-height: 2rem;
      background: ${color('indigo_700')};
      color: #fff;
      text-align: center;
    }

    &::after {
      content: '';
      border-right: 2px solid ${color('indigo_300')};
      border-bottom: 2px solid ${color('indigo_300')};
      width: 8px;
      height: 8px;
      position: absolute;
      bottom: -6px;
      right: 0;
      transform: rotate(-45deg);
    }
  }

  h4 {
    margin-bottom: 0;
  }

  p {
    font-size: 1.25rem;
    line-height: 1.75;
  }
`;

export const Badge = styled.div`
  position: relative;
  padding-left: 5rem;

  &::after {
    content: '';
    position: absolute;
    width: 1.25rem;
    height: 1.25rem;
    border: 10px solid ${color('navy_700')};
    background: #01ffc6;
    outline: 5px solid #01ffc6;
    bottom: 0;
    left: 0;
    border-radius: 100%;
  }

  &::before {
    content: '';
    position: absolute;
    bottom: 1rem;
    left: 0;
    width: 5rem;
    height: 5px;
    background: ${color('navy_700')};
  }
`;

export const BadgeDesc = styled.div`
  max-width: 350px;
`;
